<template>
  <EcxToolbarBase
    :show-toggle="true"
    :sidebar-expanded="open"
    :show-profile="true"
    :user-name="user?.name || ''"
    :user-email="user?.email || ''"
    @toggle="toggleSidebar"
    @logout="handleLogout"
    @settings="handleSettings"
  >
    <!-- Toggle icon customizado -->
    <template #toggle-icon>
      <DrawerToggleBlueIcon v-if="open" class="w-5 h-5" />
      <DrawerToggleGrayIcon v-else class="w-5 h-5 text-subtitle-gray" />
    </template>

    <!-- Informações do negócio à esquerda -->
    <template #left>
      <div
        v-if="isInitialPage && (hasBusiness || hasBusinessDetails)"
        class="hidden lg:flex items-center gap-x-2"
      >
        <p class="text-sm font-normal text-input-outline-gray">
          {{ headOfficeInformations }}
        </p>
      </div>
    </template>

    <!-- Ações à direita (settings) -->
    <template #right>
      <RouterLink
        :to="{ name: 'settings' }"
        class="h-10 w-10 flex items-center justify-center text-subtitle-gray hover:bg-gray-50 rounded-lg transition-colors"
      >
        <IconSettings class="w-5 h-5" />
      </RouterLink>
    </template>

    <!-- Menu do perfil customizado -->
    <template #profile-menu>
      <RouterLink
        :to="{ name: 'settings' }"
        class="block px-4 py-2 text-sm text-subtitle-gray hover:bg-grey-50 transition-colors"
      >
        Configurações
      </RouterLink>
    </template>
  </EcxToolbarBase>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useI18n } from '@/composables/useI18n';
import { useSidebarStore } from '@/stores/sidebar';
import { useBusinessStore } from '@/stores/business';
import { useRouter, useRoute, RouterLink } from 'vue-router';

import { Masks } from '@ecx/ui';
import { EcxToolbar as EcxToolbarBase } from '@ecx/ui';
import { IconSettings, DrawerToggleGrayIcon, DrawerToggleBlueIcon } from '@ecx/ui/icons';

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const sidebarStore = useSidebarStore();
const { user } = storeToRefs(userStore);
const { open } = storeToRefs(sidebarStore);

const { getHeadOffice, hasBusiness } = storeToRefs(useBusinessStore());
const { getBusinessDetails, hasBusinessDetails } = storeToRefs(useUserStore());

const isInitialPage = computed(() => route.name === 'tela-inicial');

const headOfficeInformations = computed(() => {
  if (hasBusiness.value) {
    return `${getHeadOffice.value?.legal_name} / ${t('toolbar.business.document')} ${Masks.cnpj(getHeadOffice.value!.cnpj)}`;
  }

  if (hasBusinessDetails.value) {
    return `${getBusinessDetails.value?.legal_name} / ${t('toolbar.business.document')} ${Masks.cnpj(getBusinessDetails.value!.cnpj)}`;
  }

  return '';
});

const toggleSidebar = () => {
  sidebarStore.toggle();
};

const handleSettings = () => {
  router.push({ name: 'settings' });
};

const handleLogout = async () => {
  await userStore.logout();
  router.push('/login?logout=true');
};
</script>
